import React, { useEffect, useState } from "react";
import { Card, Text, Loader } from "@mantine/core";
import { GoogleMap, MarkerF, OverlayViewF, OverlayView, useJsApiLoader } from "@react-google-maps/api";
import NextImage from "../../components/common/nextImage";
import { changeImageUrl } from "../../helpers/common";
import MantineAutoComplete from "../../components/mantine/autocomplete";
import { IconSearch } from "@tabler/icons-react";
import { useNavigate } from 'react-router-dom';
import { fetchAllSites, getSitesListbyclientId } from "../../store/actions";
import MantineButton from "../../components/mantine/button";
import { useDispatch, useSelector } from "react-redux";
const containerStyle = {
  width: "100%",
  height: "calc(100vh * 0.65)",
  borderRadius: "15px",
};

const center = {
  lat: 55.3781, 
  lng:  -3.4360,
};

const MapPage: React.FC = () => {
  const [searchValue, setSearchValue] = useState<any>('');
  const [loading, setLoading] = useState(true);
  const [allSites, setAllSites] = useState<any[]>([]);
  const [map, setMap] = useState<google.maps.Map | null>(null);
  const [client, setClient] = useState<{ id: number; name: string; logo: string } | null>(null);
  const [searchLocation, setSearchLocation] =
    useState<google.maps.LatLngLiteral | null>(null);
  const [selectedSite, setSelectedSite] = useState<any | null>(null);
  const navigate = useNavigate();
  useEffect(() => {
    const loginResponse = typeof window !== 'undefined' ? localStorage.getItem('client') : null;
    const ClientDetail = loginResponse ? JSON.parse(loginResponse) : null;
    setClient(ClientDetail);
  }, []);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
  });


  // const handleLoad = (map: google.maps.Map) => {
  //   const bounds = new window.google.maps.LatLngBounds()
  //   map.fitBounds(bounds)
  //   setMap(map);
  //   setLoading(false);
  // };
  
  const handleLoad = (map: google.maps.Map) => {
    if (getAllSite && getAllSite.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();
      getAllSite.forEach((site: any) => {
        if (site.latitude && site.longitude) {
          bounds.extend(new window.google.maps.LatLng(parseFloat(site.latitude), parseFloat(site.longitude)));
        }
      });
      map.fitBounds(bounds);
    } else {
      map.setCenter(center); 
    }
    setMap(map);
    setLoading(false);
  }; 
  const handleUnmount = () => {
    setMap(null);
  };
  const handleMarkerClick = (location: any) => {
    const siteId = JSON.stringify(location.siteId);
    navigate(`/dashboard/${siteId}`);
  }

  const dispatch = useDispatch();
  const { getAllSite } = useSelector((state: any) => ({
    //getAllSite: state?.getsiteData?.getSite,
    getAllSite: state?.getsiteData?.sitelist,

  }));
  useEffect(() => {
    if (selectedSite) {
      setSearchLocation({
        lat: parseFloat(selectedSite.latitude),
        lng: parseFloat(selectedSite.longitude),
      });
    } else {
      setSearchLocation(center);
    }
  }, [selectedSite]);
  
  useEffect(() => {
    if (!selectedSite && getAllSite?.length > 0) {
      setSearchLocation(center);
    }
  }, [getAllSite]);
  // useEffect(() => {
  //   setAllSites(getAllSite || []);
  //   if (getAllSite && getAllSite.length > 0) {
  //     setSearchLocation({
  //       lat: parseFloat(getAllSite[0].latitude),
  //       lng: parseFloat(getAllSite[0].longitude),
  //     });
  //   }
  // }, [getAllSite]);

  // const getList = () => {
  //   dispatch(fetchAllSites());
  // };
  const clientId = typeof window !== 'undefined' ? localStorage.getItem('clientId') : null
  const getList = () => {
    const data = {
      "clientId": clientId,
      "pageNumber": '1',
      "pageSize": '1000',
      "sortColumn": "",
      "sortDirection": "",
      "searchKeyword": searchValue
    }
    dispatch(getSitesListbyclientId(data))
  }
  useEffect(() => {
    getList();
  }, [dispatch]);

  useEffect(() => {
    setAllSites(getAllSite || []);
  }, [getAllSite]);

  
  const handleSiteSelect = (value: string) => {
    if (!value) {
      setSearchLocation(null);
      setSelectedSite(null); 
      return;
    }
    const selectedSite = allSites?.find((el: any) => el.siteName === value);
    if (selectedSite) {
      setSearchLocation({
        lat: parseFloat(selectedSite.latitude),
        lng: parseFloat(selectedSite.longitude),
      });
      setSelectedSite(selectedSite); 
    }
  };
  const handleGoClick = () => {
    if (selectedSite) {
      navigate(`/dashboard/${selectedSite.siteId}`);
    }
  };

  return (
    <div style={{ paddingTop: '6.75rem' }} className="lg:flex lg:flex-row items-start h-full w-full mx-14">
      {/* <div className="flex flex-col h-50 pt-20 justify-end items-center mr-8"> */}
      <div className="flex flex-col items-center justify-center h-full mr-8 relative top-[-20px]">
        <div className="flex justify-center max-w-[550px] max-h-[420px]">
        <NextImage
          width={302}
          height={66}
          src={client?.logo}
          style={{ width: '550px', height: '420px' }}
        />
        </div>
        <Text
          size="lg"
          className="mt-4 font-bold text-cus-38 leading-cus-46 tracking-normal text-dark_blue opacity-100 text-center"
        >
          {client?.name}
        </Text>
      </div>


      {/* Map Section */}
      <Card className="lg:w-2/3 w-full mapScreen bg-white border-2 border-sky_blue rounded-cus-27 opacity-100 relative p-1" withBorder>
       <div className="absolute z-10 mt-2 w-full flex justify-start px-4 items-center">       
          <div className="w-[400px] relative">
            <MantineAutoComplete
              placeholder="Search site"
              data={allSites?.map((data: any) => {
                return {
                  ...data,
                  label: data.siteName,
                  value: data.siteName,
                };
              })}
              onChange={handleSiteSelect}
              styleType={"mapSearch"}
              leftSection={
                <div className="mt-1">
                  <IconSearch size={24} stroke={1.5} />
                </div>
              }
            />
             <MantineButton
            ml={4}
            disabled={!selectedSite}
            onClick={handleGoClick}
            variant="filled"
            color="blue"
            className="absolute right-[1px] top-[1px] w-[70px] h-[48px] rounded-cus-40"
          >
            Go
          </MantineButton>
          
          </div>        
        </div>

        {isLoaded ? (
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={searchLocation || center}       
            zoom={6}
            onLoad={handleLoad}
            onUnmount={handleUnmount}
            options={{
              streetViewControl: false,
              mapTypeControl: false,
              fullscreenControl: false,
              zoomControl: false,
              keyboardShortcuts: false,
              clickableIcons: false,         
            }}
          >
            {allSites?.filter((location: any) => location.latitude && location.longitude) ?.map((location, index) => (
              <>
                <MarkerF
                  key={`marker-${index}`}
                  position={{
                    lat: parseFloat(location.latitude),
                    lng: parseFloat(location.longitude),
                  }}
                  onClick={() => handleMarkerClick(location)}
                />
                <OverlayViewF
                  key={`label-${index}`}
                  position={{
                    lat: parseFloat(location.latitude),
                    lng: parseFloat(location.longitude),
                  }}
                  mapPaneName={OverlayView.OVERLAY_LAYER}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{
                      color: 'maroon',
                      fontWeight: 'bold',
                      marginLeft: '8px',
                      whiteSpace: 'nowrap',
                      fontSize: '14px',
                    }}>
                      {location.siteName.split(".").join(" ")}
                    </span>
                  </div>
                </OverlayViewF>
              </>
            ))}
          </GoogleMap>
        ) : (
          <Loader />
        )}
      </Card>

    </div>
  );
};

export default MapPage;
